module.exports = __webpack_public_path__ + "img/offers_illustration_pack.9c66ed1c.svg";